export function textToClassName(str: string) {
  return str.toLowerCase().replace(/\W/, '-')
}
